// Bookie Pearl ("Marvarid") — variant that renders the standalone
// HTML template (1920s Gatsby-elegant pearl + silver 25TH WEDDING
// ANNIVERSARY: pearl #F4F4F0 paper, silver #C4C6C0 ornaments, a
// faint pearl-blue highlight, Italiana display + Cormorant
// Garamond italic body + Pinyon Script accent, art-deco half-fan
// at the hero, giant silver "25" numeral, a five-photo through-the-
// years gallery, a three-card kids' tribute, and a champagne toast
// quote) inside a full-bleed iframe. The HTML lives at
// /templates/bookie-pearl.html and reads names/date/venue/etc. from
// its iframe URL so the customizer can swap mocks before first
// paint.
//
// We pass payload values via the URL because postMessage would race
// the iframe's first paint and the customizer needs to run before
// the IntersectionObserver inside the HTML attaches.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/bookie-pearl.html";

export function BookiePearlStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  if (t.names) params.set("names", t.names);
  if (t.date) {
    // Convert dd.mm.yyyy → ISO yyyy-mm-dd for the customizer.
    const m = t.date.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (m) params.set("date", `${m[3]}-${m[2]}-${m[1]}`);
    else params.set("date", t.date);
  }
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (t.time) params.set("time", t.time);
  // Demo / preview surfaces leave ctx.slug undefined.
  if (ctx.slug) params.set("slug", ctx.slug);
  // Anniversary gala keeps the optional music toggle — when the
  // invitation payload picks a track, we forward it as ?audio=, and
  // the template's iOS-aware play handler does the rest.
  if (t.musicTrackId) params.set("audio", `/music/${t.musicTrackId}.mp3`);
  // Cache buster — bump when the static HTML changes.
  params.set("v", "3");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;

  return (
    <iframe
      src={src}
      title={t.names || "Kamila & Bekzod"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#F4F4F0",
      }}
    />
  );
}
